import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { CreditCard, ArrowRight } from 'lucide-react';

export default function SubscriptionsPage() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl lg:text-3xl font-outfit font-bold text-slate-900">
            Subscriptions
          </h1>
          <p className="text-slate-500 mt-1">
            Manage your active service subscriptions
          </p>
        </div>

        <Card className="p-12 text-center rounded-2xl border border-slate-100">
          <div className="w-16 h-16 bg-sky-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <CreditCard className="w-8 h-8 text-sky-400" />
          </div>
          <h3 className="text-lg font-semibold text-slate-700 mb-2">
            No Active Subscriptions
          </h3>
          <p className="text-slate-500 text-sm mb-6 max-w-sm mx-auto">
            Explore our services and apply to get expert guidance for your study
            abroad journey.
          </p>
          <Button
            className="rounded-xl bg-gradient-to-r from-sky-600 to-blue-600 text-white hover:from-sky-700 hover:to-blue-700 shadow-md shadow-sky-500/20"
            onClick={() => navigate('/dashboard/services')}
          >
            Explore Services
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Card>
      </div>
    </DashboardLayout>
  );
}
